import { render, staticRenderFns } from "./MicrosoftOutlook.vue?vue&type=template&id=851896e4"
import script from "./MicrosoftOutlook.vue?vue&type=script&lang=js"
export * from "./MicrosoftOutlook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports